import Vue from 'vue'

// plugins/filters 以下を全て読み込む
const requireFilter = require.context('./filters', true)
requireFilter.keys().forEach(fileName => {
  let filterFunction = requireFilter(fileName)
  filterFunction = filterFunction.default || filterFunction
  const filterName = fileName.replace(/^.+\//, '').replace(/\.\w+$/, '')
  Vue.filter(filterName, filterFunction)
})
